const SEC = require('common/js/utils/core.js');

let state = {
    // 购物车数据
    cartData: {},
    // 购物车所有商品列表
    cartList: [],
    // 顶部提示信息是否显示,默认显示
    isTipsShow: true,
    // 是否显示税金的遮罩
    isTaxMaskShow: false,
    // upk
    upk: SEC.cookie.get('Sid') || process.env.UPK,
    // 是否显示toast提示框
    isToastShow: false,
    // toast提示框文字
    toastDesc: '',
    // 是否为编辑状态
    isEdit: false,
    // loading状态
    isLoadingShow: false,
    // 提示框信息
    confirm: {
        isShow: false,
        data: {}
    }
};

export default state;



// WEBPACK FOOTER //
// ./src/store/state.js